import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import Switch, { Case } from "react-switch-case";
import {
  comma,
  partnerIcon,
  getOrderTypeStyle,
  getOrderInfoText,
  baeminMobileOrderFg,
  selfDlvMobileOrderFg,
} from "utils/Utils";
import OrderListButtonCase from "pages/layers/orderDetail/OrderListButtonViewCase";
import BaeminOrderListButtonViewCase from "pages/layers/orderDetail/BaeminOrderListButtonViewCase";
import { fn_orderDetail, fn_orderEndDetail } from "function/FnBodyDetail";
import { MobileOrderFg, StepCd } from "types";

const OrderListTypeItemView = ({ rootStore, order, index }) => {
  const searchStore = rootStore.searchStore;
  const orderList = rootStore.orderStore.getOrderList;

  useEffect(() => {
    rootStore.orderStore.setOrderListStyle({ mobileOrderNo: order.mobileOrderNo, onStyle: false });
  }, [rootStore, order]);

  if (order.partnerType === "BAEMIN") {
    if (order.morderTypeCd === "P") {
      order.partnerType = "BAEMIN_PICKUP";
    } else if (order.morderTypeCd === "O") {
      order.partnerType = "BAEMIN_SHOP";
    }
  }

  let img_icon = partnerIcon(order.partnerType);

  let checkOnStyle;
  rootStore.orderStore.getOrderListStyle.map(data => {
    if (data.mobileOrderNo === order.mobileOrderNo) {
      checkOnStyle = data.onStyle;
    }
  });

  let orderTypeStyle = getOrderTypeStyle(order.orderType);

  let checkCallBack = order.mobileOrderFg === "29" || order.mobileOrderFg === "30" ? true : false;
  let infoText = getOrderInfoText(order);

  let message;
  let mshopMessage;
  if (order.shopMessage) {
    message = order.shopMessage.replace(/`/g, "").substring(order.shopMessage.indexOf("제]")).split("|");
    mshopMessage = message[0].trim();
  }

  let menuText;
  if (order.viewProds != null) {
    if (order.viewProds[0] != undefined && order.viewProds.length > 0) {
      if (order.viewProds[0].prodName?.length > 20) {
        menuText = order.viewProds[0].prodName.substring(0, 20) + "...";
      } else {
        menuText = order.viewProds[0].prodName;
      }
    }
  }

  let timeClass = "";
  let timeCnt = "";
  let timeReceipt = true;

  if (200 > parseInt(order.stepCd) || parseInt(order.stepCd) > 600 || Number(order.time) < -180 || order.time == null) {
    timeClass = "time default";
    timeCnt = order.orderTimeView + " 주문";
    timeReceipt = false;
  } else {
    if (Number(rootStore.settingStore.getCookingDfTime) <= Number(order.time)) {
      timeClass = "time time_noraml";
      timeCnt = order.time + "분 남음";
    } else if (0 <= Number(order.time) < Number(rootStore.settingStore.getCookingDfTime)) {
      if (0 <= Number(order.time * -1) && Number(rootStore.settingStore.getCookingDfTime) * -1 < Number(order.time)) {
        timeClass = "time time_over";
        timeCnt = Number(order.time * -1) + "분 경과";
      } else if (Number(order.time) <= Number(rootStore.settingStore.getCookingDfTime) * -1) {
        timeClass = "time time_max";
        timeCnt = Number(order.time * -1) + "분 경과";
      } else {
        timeClass = "time time_alert";
        timeCnt = order.time + "분 남음";
      }
    }
  }

  if ((order.mobileOrderFg == "29" || order.mobileOrderFg == "31") && order.elapseTime == "0") {
    timeReceipt = true;
  }

  return (
    <li
      className={checkOnStyle ? "on" : null}
      style={orderList.length === index + 1 ? { borderBottom: "1px solid #ddd" } : null}
    >
      <button
        type="button"
        onClick={event => {
          order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED
            ? fn_orderEndDetail(rootStore, order.mobileOrderNo, "endOrderView")
            : fn_orderDetail(rootStore, order.mobileOrderNo, "order");
        }}
      >
        <span className="thumb">
          <span className="img">
            <img src={img_icon} width="30" height="30" alt={"logo"} />
            <span className="frame"></span>
          </span>
          {order.new_yn === "Y" ? <span className="new"></span> : ""}
        </span>
        <span className="tit_order">
          <span className="order_num">
            {baeminMobileOrderFg(order.mobileOrderFg) ? order.mobileOrderNo.slice(-4) : order.mobileOrderNoView}
          </span>
          <span className={orderTypeStyle}>
            {order.selfDeliveryType != null && order.selfDeliveryType != ""
              ? order.orderTypeView + "(" + order.selfDeliveryType + ")"
              : order.orderTypeView}
          </span>
        </span>
        <span className="cont">
          <span className="location">
            {order.tableNo && order.maxOidSeqNo > 0
              ? `테이블 ${order.tableNo} (최종주문차수 ${order.maxOidSeqNo.toString().padStart(3, "0")})`
              : order.mobileOrderFg === MobileOrderFg.KIOSK
              ? "키오스크 주문 " +
                order.mobileOrderNoView +
                (order.bellNo || order.deliverNo ? " / 진동벨 " + (order.bellNo || order.deliverNo) : "")
              : order.mobileOrderFg === MobileOrderFg.POS_PREPAID
              ? "포스 선불 주문 " +
                order.mobileOrderNoView +
                (order.bellNo || order.deliverNo ? " / 진동벨 " + (order.bellNo || order.deliverNo) : "")
              : order.mobileOrderFg === MobileOrderFg.TABLE_ORDER
              ? "테이블오더 주문 " +
                order.mobileOrderNoView +
                (order.bellNo || order.deliverNo ? " / 진동벨 " + (order.bellNo || order.deliverNo) : "")
              : order.mobileOrderFg === MobileOrderFg.QR_ORDER
              ? "QR오더 주문 " +
                order.mobileOrderNoView +
                (order.bellNo || order.deliverNo ? " / 진동벨 " + (order.bellNo || order.deliverNo) : "")
              : infoText}
          </span>
          <span className="more">
            <span className="pay">
              {comma(order.orderAmount)}원
              <span>
                {order.payTypeView === "선불" || order.payTypeView === "후불"
                  ? "(" + order.payTypeView + ")"
                  : order.payTypeView}
              </span>
            </span>
            <span className="menu">
              {menuText}
              {Number(order.mainMenuCount - 1) > 0 ? " 외 " + Number(order.mainMenuCount - 1) + "개" : null}
            </span>
            {mshopMessage ? <span className="other">요청</span> : null}
            {order.isPartialCanceled ? <span className="other cancel">부분취소</span> : null}
            {order.over ? <span className="other over">과적</span> : null}
            {order.orderType === "DELIVERY" &&
            order.mobileOrderFg === "23" &&
            !(order.cstTelNo == null || order.cstTelNo == "") ? (
              <span className="phone">{order.cstTelNo}</span>
            ) : null}
          </span>
        </span>
      </button>
      <span className="state">
        {order.orderType === "DELIVERY" ? (
          <Switch condition={order.stepCd}>
            <Case value="200">배차전</Case>
            <Case value="500">
              <Switch condition={order.dlvStatusFg ? (order.mobileOrderFg == "30" ? "05" : order.dlvStatusFg) : ""}>
                <Case value="00">배차중</Case>
                <Case value="02">픽업중</Case>
                <Case value="03">배달중</Case>
                <Case value="04">배달완료</Case>
                <Case value="">배차전</Case>
                <Case value="99">배차전</Case>
                <Case value="05">진행중</Case>
              </Switch>
            </Case>
          </Switch>
        ) : checkCallBack ? (
          <Switch condition={order.stepCd}>
            <Case value="200">진행중</Case>
            <Case value="300">조리중</Case>
          </Switch>
        ) : (
          <Switch condition={order.stepCd}>
            <Case value="200">조리중</Case>
            <Case value="300">호출</Case>
          </Switch>
        )}
      </span>
      <span
        className={
          order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED ? "btn end" : "btn"
        }
      >
        {baeminMobileOrderFg(order.mobileOrderFg) ? (
          <BaeminOrderListButtonViewCase rootStore={rootStore} order={order} searchStore={searchStore} />
        ) : (
          <OrderListButtonCase rootStore={rootStore} order={order} searchStore={searchStore} />
        )}
      </span>
      {selfDlvMobileOrderFg(order.mobileOrderFg) ? (
        (order.mobileOrderFg === MobileOrderFg.BAEMIN_ONE || order.mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS) &&
        order.elapseTime == "0" ? (
          <span className="time txt">조리대기</span>
        ) : (
          <span
            className={
              200 > parseInt(order.stepCd) ||
              parseInt(order.stepCd) > 600 ||
              Number(order.time) < -180 ||
              order.time == null
                ? "time default"
                : Number(order.time) >= 0
                ? "time pickup"
                : "time pickup over"
            }
          >
            {200 > parseInt(order.stepCd) ||
            parseInt(order.stepCd) > 600 ||
            Number(order.time) < -180 ||
            order.time == null
              ? order.orderTimeView + " 주문"
              : Number(order.time) < 0
              ? order.time * -1 + "분 경과"
              : order.time + "분  픽업"}
          </span>
        )
      ) : (
        <span className={timeClass}>{timeCnt}</span>
      )}
      {!timeReceipt ? "" : <span className="time receipt">{order.orderTimeView} 주문</span>}
    </li>
  );
};

export default inject("rootStore")(observer(OrderListTypeItemView));
